import { Icon, type IconProps } from "../icon";

const PATHS = [
  "M5.0996 5C5.0996 3.346 6.4456 2 8.0996 2C9.7536 2 11.0996 3.346 11.0996 5C11.0996 6.654 9.7536 8 8.0996 8C6.4456 8 5.0996 6.654 5.0996 5ZM15.8036 12.905C14.9056 10.982 13.3236 9.509 11.4336 8.699C12.4486 7.783 13.0996 6.471 13.0996 5C13.0996 2.243 10.8566 0 8.0996 0C5.3426 0 3.0996 2.243 3.0996 5C3.0996 6.471 3.7506 7.783 4.7656 8.699C2.8746 9.51 1.2916 10.984 0.393598 12.909C0.160598 13.409 0.376598 14.004 0.876598 14.238C1.0136 14.302 1.1576 14.332 1.2996 14.332C1.6756 14.332 2.0366 14.118 2.2056 13.754C3.2706 11.474 5.5836 10 8.0996 10C10.6146 10 12.9276 11.473 13.9926 13.752C14.2266 14.253 14.8246 14.468 15.3216 14.234C15.8216 14.001 16.0376 13.406 15.8036 12.905Z",
];

export function HelpYouIcon(props: IconProps) {
  return <Icon paths={PATHS} {...props} />;
}
